/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Brief_PlaceholderInputs */

const cs_templates_ai_brief_placeholder = /** @type {(inputs: Templates_Ai_Brief_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`např. Instagram čtverec, tmavě modrý overlay, oranžový akcent, logo vlevo nahoře, cena vpravo dole…`)
};

const en_templates_ai_brief_placeholder = /** @type {(inputs: Templates_Ai_Brief_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Instagram square, dark navy overlay, orange accent, logo top-left, price badge bottom-right…`)
};

/**
* | output |
* | --- |
* | "e.g. Instagram square, dark navy overlay, orange accent, logo top-left, price badge bottom-right…" |
*
* @param {Templates_Ai_Brief_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_brief_placeholder = /** @type {((inputs?: Templates_Ai_Brief_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Brief_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_brief_placeholder(inputs)
	return cs_templates_ai_brief_placeholder(inputs)
});